/**
 * Wishlist count badge — mobile SSC + desktop native heart.
 * The count always comes from Wishlist Hero's own data: we never count clicks ourselves.
 *
 * Wishlist Hero keeps the items in localStorage ("wishlisthero_.wl-itms", store2 namespace) and
 * WishListHero_SDK.GetWishListItemsCount() just returns that array's length — but the SDK answers
 * { ok: false } on plans without the JS API, so the storage is read directly as the primary source.
 * Note: "wishlist-hero-wishlist-items*" events are SDK *requests*, not change notifications —
 * listening to them would make us loop on our own calls.
 */
(function () {
  'use strict';

  var WLH_ITEMS_KEY = 'wishlisthero_.wl-itms';
  var scheduled = false;
  var lastPainted = -1;

  // Values left by the previous click-counting implementation
  try {
    localStorage.removeItem('ssc_wlh_count_v1');
    localStorage.removeItem('ssc_wlh_count_v2');
  } catch (_) {}

  function getCountFromStorage() {
    try {
      var raw = localStorage.getItem(WLH_ITEMS_KEY);
      if (raw == null) return 0;
      var items = JSON.parse(raw);
      return Array.isArray(items) ? items.length : 0;
    } catch (_) {
      return null;
    }
  }

  function getCountFromSdk() {
    try {
      var sdk = window.WishListHero_SDK;
      if (!sdk || typeof sdk.GetWishListItems !== 'function') return null;
      var items = sdk.GetWishListItems();
      if (Array.isArray(items)) return items.length;
    } catch (_) {}
    return null;
  }

  function getCount() {
    var n = getCountFromStorage();
    if (n == null) n = getCountFromSdk();
    return n != null ? n : 0;
  }

  function paint(el, count) {
    if (!el) return;
    if (count > 0) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.style.setProperty('display', 'flex', 'important');
      el.classList.add('wishlist-hero-items-count-exists');
      el.removeAttribute('hidden');
    } else {
      el.textContent = '';
      el.style.setProperty('display', 'none', 'important');
      el.classList.remove('wishlist-hero-items-count-exists');
    }
  }

  function ensureBadgeOnLink(link) {
    if (!link || link.classList.contains('ssc-wlh-count-anchor')) return null;
    link.classList.add('ssc-wishlist-link--badged');
    link.setAttribute('data-ssc-wishlist-link', '');
    if (!link.style.position || link.style.position === 'static') {
      link.style.position = 'relative';
    }
    var span =
      link.querySelector(':scope > .ssc-header__wishlist-count') ||
      link.querySelector(':scope > span.wishlist-hero-items-count');
    if (!span) {
      span = document.createElement('span');
      span.className = 'wishlist-hero-items-count wishlist-hero-items-count-text-plain ssc-header__wishlist-count';
      span.setAttribute('aria-hidden', 'true');
      link.appendChild(span);
    } else {
      span.classList.add('ssc-header__wishlist-count', 'wishlist-hero-items-count-text-plain');
    }
    return span;
  }

  function isVisibleWishlistHeart(a) {
    if (!a || a.tagName !== 'A') return false;
    if (a.classList.contains('ssc-wlh-count-anchor')) return false;
    if (a.classList.contains('ssc-wlh-duplicate-heart')) return false;
    if (a.closest('.ssc-mobile-root, .ssc-mobile-only')) return false;
    if (!a.closest('#header-group, header-actions')) return false;

    var href = (a.getAttribute('href') || '').trim();
    var hasIcon = !!(a.querySelector('svg, img, .icon, .svg-wrapper'));
    var label = ((a.getAttribute('aria-label') || '') + ' ' + (a.getAttribute('title') || '')).toLowerCase();

    if (href === '#hero-wishlist' && hasIcon) return true;
    if (href.indexOf('/a/wishlist-hero/wishlist') !== -1 && hasIcon) return true;
    if (hasIcon && (label.indexOf('wishlist') !== -1 || label.indexOf('souhaits') !== -1 || label.indexOf('favori') !== -1)) {
      return true;
    }
    if (hasIcon && a.querySelector('svg path[d*="20.84"], svg path[d*="M20.84"], svg path[d*="M12 21"]')) {
      return true;
    }
    return false;
  }

  function cleanupDesktop() {
    // Remove hearts we injected earlier
    document.querySelectorAll('#header-group .ssc-desktop-wishlist-link').forEach(function (el) {
      el.remove();
    });

    // Mark icon-less #hero-wishlist as hidden (do not remove — WLH binds them)
    document.querySelectorAll('#header-group a[href="#hero-wishlist"], header-actions a[href="#hero-wishlist"]').forEach(function (a) {
      if (a.closest('.ssc-mobile-root, .ssc-mobile-only')) return;
      var hasIcon = !!(a.querySelector('svg, img, .icon, .svg-wrapper'));
      if (!hasIcon) {
        a.classList.add('ssc-wlh-count-anchor');
        a.setAttribute('aria-hidden', 'true');
        a.setAttribute('tabindex', '-1');
      }
    });
  }

  function enhanceDesktop() {
    cleanupDesktop();
    var links = [];
    document.querySelectorAll('#header-group a, header-actions a').forEach(function (a) {
      if (isVisibleWishlistHeart(a)) links.push(a);
    });

    links.forEach(function (link, idx) {
      if (idx === 0) {
        ensureBadgeOnLink(link);
        link.style.removeProperty('display');
        link.removeAttribute('hidden');
      } else {
        link.classList.add('ssc-wlh-duplicate-heart');
        link.setAttribute('aria-hidden', 'true');
        link.style.display = 'none';
      }
    });
  }

  function updateAll() {
    var badgeExists = !!document.querySelector('#header-group a[data-ssc-wishlist-link]');
    var count = getCount();

    if (badgeExists && count === lastPainted) return;

    enhanceDesktop();
    lastPainted = count;

    // Mobile SSC badge
    document.querySelectorAll('.ssc-header__wishlist .ssc-header__wishlist-count, .ssc-header__wishlist .wishlist-hero-items-count').forEach(function (el) {
      if (el.closest('.ssc-wlh-count-anchor')) return;
      paint(el, count);
    });

    // Desktop badged heart only
    document.querySelectorAll('#header-group a[data-ssc-wishlist-link] .ssc-header__wishlist-count').forEach(function (el) {
      if (el.closest('.ssc-wlh-count-anchor, .ssc-wlh-duplicate-heart')) return;
      paint(el, count);
    });
  }

  // WLH dispatches "updated" right *before* writing the item to storage: always read after a tick
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      updateAll();
    }, 50);
  }

  ['wishlist-hero-wishlist-sdk-ready', 'wishlist-hero-wishlist-updated', 'wishlist-hero-links-binded', 'ssc-wishlist-changed'].forEach(
    function (name) {
      document.addEventListener(name, schedule);
    }
  );

  // Header may be re-rendered (section hydration): re-place the badge
  document.addEventListener('shopify:section:load', schedule);

  // Wishlist changed in another tab
  window.addEventListener('storage', function (e) {
    if (e.key === WLH_ITEMS_KEY) schedule();
  });

  // WLH syncs its storage from the server after load without always firing an event: re-check for a few seconds
  // (cheap: updateAll returns early when the count hasn't changed)
  function settle(attempt) {
    updateAll();
    if (attempt < 20) setTimeout(settle, 500, attempt + 1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      settle(0);
    });
  } else {
    settle(0);
  }

  window.__sscUpdateWishlistCount = schedule;
})();
